export const COOKIE_CONSENT_STORAGE_KEY = 'lumenverde_cookie_consent_v1';
export const COOKIE_CONSENT_CHANGED_EVENT = 'lumenverde:cookie-consent-changed';
export const OPEN_COOKIE_SETTINGS_EVENT = 'lumenverde:open-cookie-settings';

const isValidConsent = (value) =>
  Boolean(
    value &&
      typeof value === 'object' &&
      typeof value.analytics === 'boolean' &&
      typeof value.savedAt === 'string' &&
      !Number.isNaN(Date.parse(value.savedAt))
  );

export function getCookieConsent() {
  if (typeof window === 'undefined') return null;

  try {
    const storedValue = window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (!storedValue) return null;

    const consent = JSON.parse(storedValue);
    return isValidConsent(consent) ? consent : null;
  } catch {
    return null;
  }
}

export function saveCookieConsent(analytics) {
  const consent = {
    analytics: analytics === true,
    savedAt: new Date().toISOString(),
  };

  if (typeof window !== 'undefined') {
    try {
      window.localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, JSON.stringify(consent));
    } catch {
      // A döntés az aktuális munkamenetben akkor is érvényesül, ha a tároló nem elérhető.
    }

    window.dispatchEvent(
      new CustomEvent(COOKIE_CONSENT_CHANGED_EVENT, { detail: consent })
    );
  }

  return consent;
}

export function openCookieSettings() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(OPEN_COOKIE_SETTINGS_EVENT));
  }
}
